import TeamStore from "../store";
import { action } from "satcheljs/lib/legacy";

export let updateTeamLocation = action("updateTeamLocation")(
    /**
     * Updates the location of the current team
     */
    function updateTeamLocation(teamLocation: string) {
        TeamStore().team.location = teamLocation;
    });